import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Typography } from '@mui/material';

export default function PavoLoader(props) {
    const { text } = props;

    let loadingText = text ? text : 'Loading…';

    return (
        <React.Fragment>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '100px',
                }}
            >
                <Typography variant="h6">{loadingText}</Typography>
            </div>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '100px',
                    width: '100%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                }}
            >
                <CircularProgress fontSize="small" />
            </div>
        </React.Fragment>
    );
}

PavoLoader.propTypes = {
    text: PropTypes.string,
};
